import { isValidUUID } from "@zapier/canvas-state";

export function isDraftOrTemplateNode(id: string) {
  return !isValidUUID(id);
}
